import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { useTranslation } from 'next-i18next';

const mapQueryCrumbs = data => {
  const lastCategory = data[data?.length - 1 || 0];

  let prevCategories = lastCategory?.breadcrumbs?.map(category => {
    return {
      name: category.category_name,
      path: category.category_url_key,
      level: category.category_level
    };
  });

  const lastCategoryCrumbs = {
    name: lastCategory?.name,
    path: lastCategory?.url_key,
    level: lastCategory?.level
  };
  if (!prevCategories) {
    prevCategories = [];
  }
  return [...(prevCategories && prevCategories), lastCategoryCrumbs];
};

const mapProductCrumbs = data => {
  if (data.length > 0) {
    const levelTwo = data.find(({ level }) => level === 2);
    const levelThree = data.find(({ level }) => level === 3);

    const crumbs = data.map(crumb => {
      let path = '/kataloog';

      if (crumb.level === 2) {
        path += `/${crumb.path}`;
      } else if (crumb.level === 3) {
        path += `/${levelTwo?.path}/${crumb.path}`;
      } else if (crumb.level === 4) {
        path += `/${levelTwo?.path}/${levelThree?.path}/${crumb.path}`;
      }

      return { name: crumb.name, path };
    });

    return crumbs;
  } else return null;
};

export default function useProductBreadcrumbs(product) {
  const { t } = useTranslation();

  const { asPath: currentPath } = useRouter();

  const [queryCrumbs, setQueryCrumbs] = useState([]);
  const [crumbs, setCrumbs] = useState([]);

  const { name, categories } = product || {};

  useEffect(() => {
    if (categories) {
      const queryCrumbs = mapQueryCrumbs(categories);
      if (queryCrumbs) setQueryCrumbs(queryCrumbs);
    }
  }, [categories]);

  useEffect(() => {
    const crumbs = mapProductCrumbs(queryCrumbs);

    if (crumbs) {
      const breadcrumbs = [
        { name: t('ui.home'), path: '/' },
        ...crumbs,
        { name, path: currentPath }
      ];

      setCrumbs(breadcrumbs);
    }
  }, [queryCrumbs]);

  return crumbs;
}
